import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { IKTRichText, TResolvedImage } from "@/types/kontent.types"
import { cn } from "@/lib/utils"
import { RichTextSync, Typography } from "@/components/ui/atoms"
import { Picture } from "@/components/ui/molecules"

export interface IImageAndTextProps {
  asChild?: boolean
  reverse?: boolean
  title: string
  body?: IKTRichText
  image: Partial<TResolvedImage>
  isInArticle?: boolean
}
const ImageAndText = React.forwardRef<HTMLDivElement, IImageAndTextProps>(
  (
    {
      asChild = false,
      reverse = false,
      title,
      image,
      body,
      isInArticle = false,
      ...props
    },
    ref
  ) => {
    const Component = asChild ? Slot : "div"
    return (
      <Component
        className="image-and-text bg-secondary-500"
        ref={ref}
        {...props}
      >
        <div className={cn(isInArticle ? "" : "container")}>
          <div
            className={cn(
              "items-center md:flex",
              reverse ? "md:flex-row-reverse" : ""
            )}
          >
            {image.width && image.height ? (
              <Picture
                src={(image.src ?? "") + "?h=1800&w=1600&fm=webp&q=80"}
                alt={image.alt ?? ""}
                width={image.width}
                height={image.height}
                className="self-end pb-8 pt-10 md:w-5/12 md:pb-0 md:pt-12"
                isSemiCircle={true}
                alignLeft={!reverse}
              />
            ) : null}
            <div className="md:w-1/12"></div>
            <div className="pb-10 md:w-6/12 md:pb-5">
              <Typography as="h2" variant="headingL" className="mb-7">
                {title}
              </Typography>
              {body ? (
                <div className="paragraph-m">
                  <RichTextSync blockTitle={title} body={body} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Component>
    )
  }
)
ImageAndText.displayName = "ImageAndText"

export { ImageAndText }
